import _styled from "styled-components";
import cn from "clsx";
import { css } from "styled-components";
import { CourseEnrollmentHorizontalCardSkeleton } from "../../../../../../../components/Cards/CourseEnrollmentHorizontalCard";
import { jsx as _jsx } from "react/jsx-runtime";
var VISIBLE_COURSE_COUNT = 4;
var SideCoursesListSkeleton = function SideCoursesListSkeleton(_ref) {
  var className = _ref.className,
    isDark = _ref.isDark;
  return /*#__PURE__*/_jsx(_StyledDiv, {
    className: cn('w-full h-full flex flex-col overflow-hidden', className)
    // @ts-ignore
    ,

    children: Array.from({
      length: VISIBLE_COURSE_COUNT
    }).map(function (_, i) {
      return /*#__PURE__*/_jsx(CourseEnrollmentHorizontalCardSkeleton, {
        className: cn({
          'mb-16': i < VISIBLE_COURSE_COUNT - 1
        }),
        isDark: isDark
      }, "card-skeleton-".concat(i.toString()));
    })
  });
};
export default SideCoursesListSkeleton;
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  componentId: "sc-1v4w0y7-0"
})(["\n      ", " {\n        max-height: 358px;\n      }\n    "], function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up('md');
});